// extracted by mini-css-extract-plugin
module.exports = {"header__nav-item":"HeaderNavItem_header__nav-item__dx53z"};